import { updateKeyInStore } from 'App';
import { updateKey } from '../slice';

import { fields } from '../fields';

type UploadFields = typeof fields;

export const uploadFields: UploadFields = [
  {
    name: 'form5498ReportingIraorRothIraContributionForTaxYear',
    label: 'Form 5498 reporting IRA (or ROTH IRA) contribution for tax year',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.passiveIncome.pension.values.didYouMakeContributionsToAUsIraRothIraOrSepAccountsDuringTheFilingYear',
  },
  {
    name: 'doYouHaveForm5498',
    label: 'Do you have Form 5498?',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.passiveIncome.pension.values.didYouMakeContributionsToAUsIraRothIraOrSepAccountsDuringTheFilingYear',
  },
  {
    name: 'pleaseUploadForm1099ROrSsa1099',
    label: 'Please upload form 1099-R or SSA-1099',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.passiveIncome.pension.values.didYouReceiveUsRetirementDistributions',
  },
  {
    name: 'pleaseUploadSupportingDocumentation',
    label: 'Please upload supporting documentation',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.income.passiveIncome.pension.values.didYouPerformARolloverBetweenTraditionalIraAndRothIra',
  },
  {
    name: 'pleaseUploadSupportingDocumentationFullDetails',
    label: 'Please upload supporting documentation & full details',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.income.passiveIncome.pension.values.didYouPerformARolloverBetweenNonUSRetirementAccounts',
  },
];
